<div class="padding-content events-page">
    <div class="content-table-events" *ngIf="idVenue">
        <app-events-panel [idVenue]="idVenue"></app-events-panel>
    </div>
</div>